import { pageNote } from '../interfaces/pageNote';
import ResizeObserver from 'resize-observer-polyfill';
import * as Shepherd from '../../../../../org/Hibachi/client/lib/shepherd.js/dist/js/shepherd.min.js';
import { LocalStorageService } from '@DavisDigital/davisdigitalfrontend.module';

declare var pdfjsLib;
declare var $;
declare var angular;
declare var pdfjsViewer;

var DEFAULT_SCALE_DELTA = 1.1;

class BookSingleController {
	//book preview props
	public bookId;
	public previewFlag;
	
	//book single props
	public bookID;
	public bookDetails:any;
	public spread;
	public chapters: Array<any> = [];
	public resources: any = [];
	public activeVideoResource: any;
	public pageNotes: Array<pageNote>;
	public selectingCoordinate: boolean = false;
	public isNotesVisible: boolean = false;
	public currentImageURL: string = '';
	public viewAs: string = 'spread';
	public renderType: string = null;
	public isPresentationMode: boolean = false;
	public pageNumber: number;
	public pageRepresentation: string;
	public spreadPageRepresentation: string;
	public pageIDs: Array<string> = [];
	public numberOfPages: (number|null) = null;
	public totalPageRepresentation: string;
	public pageImages: Array<string> = [];
	public hasPageImages:boolean = false; //flag to check if page images exist
	public isBookAssetVisible:boolean = false;
	public pageVideos: Array<string> = [];
	public goToValue: string;
	
	private mediaContainer;
	private imageContainer;
	private pdfContainer;
	private canvas;

	// PDF Specific Variables
	private mediaWidth;
	private pdfDoc;
	private canvasContext;
	private isRendering: boolean = false;
	private queuedDrawCanvas: boolean = false;
	public viewType:string;
	private zoom: number = 100;
	private pdfViewerIntialScale; number;

	// jQuery element object
	private zoomSlider: any;
	
	private s3LinkExpireyTime?: number = null;

	//Preview + Page Share Variables
	public bookPreview: boolean = false;
	public sharedToken: string = "";
	public sharedPageList: any;
	public pageShareEmail: string = "";
	public pageShareSubject: string = "";
	public pageShareBody: string = "";
	public pageShareSuccess:boolean = false;
	public pageShareLoading:boolean = false;
	public searchedKeyword: string = "";
	public pageErrors: string = "";
	public pdfSinglePageViewerObj;
	public bookCode: string;
	
	// @ngInject
	constructor( 
		public $q,
		public $attrs, 
		public $scope,
		public $timeout,
		public bookService,
		public apiService,
		public observerService,
		public $location,
		public $sce,
		public ModalService,
		public localStorageService,
		public davisAlertService
	) {}

	public $onInit = () => {

		// Get URL Param for pageNumber
		if ( 'undefined' == typeof this.pageNumber && 'undefined' !== typeof this.$location.search().pageNumber ) {
			this.pageNumber = +this.$location.search().pageNumber;
		}else if('undefined' == typeof this.pageNumber){
			this.pageNumber = 1;
		}
		
		this.sharedToken = this.$attrs.sharedToken;
		this.bookPreview = this.$attrs.bookPreview;

		
		this.viewType = this.$location.search().viewType;
		
		if(this.viewType == null){
			this.viewType = 'standard';
		}

		if ( 'undefined' !== typeof this.$location.search().viewAs ) { // Get URL Param for viewAs 
			this.viewAs = this.$location.search().viewAs;
			this.$timeout( () => $('.selectpicker').selectpicker('refresh') );
		}
		
	

		if ( null === pdfjsLib ) {
			console.warn("PDFJS isn't loaded properly");
			return;
		}

		//for book preview case
		if(this.bookID == null && this.bookId != null && this.bookId.length == 32){
			this.bookID = this.bookId
		}

		if ( 'undefined' === typeof this.bookID ) {
			this.bookID = this.$attrs.bookId;
		}
		
		this.getMediaContainer();
		this.imageContainer = document.getElementById('image-container');
    	this.pdfContainer = document.getElementById("viewerContainer");
		
	    this.getBookDetails()
	    .then(()=>{
	    	//set view type to single when viewing shared pages or spread view is disabled
			if( this.bookDetails.disableSpreadViewFlag==true){
				this.viewAs = "single";
			}
		}).then(()=>{
			if ( this.sharedToken != "" ) {
				return	this.$q.all( [ this.getSpreadForBook() ] )
			} else {
				return	this.$q.all( 
					[ 
						this.getSpreadForBook(),
						this.getChapters(),
						this.getResources(),
						this.initShepherd()
					]
				)
			}
		}).finally( ()=>{
			if(this.viewType === 'present'){
				this.togglePresentationMode();
			}

		});
		
		this.renderRangeSlider();

		$('#bookSingleVideoModal').on('hidden.bs.modal', () => {
			// Refresh iframe src to stop it
			this.activeVideoResource = null;
			this.$scope.$apply();
			$('#bookSingleVideoModal iframe').attr( 'src', $('#bookSingleVideoModal iframe').attr('src') );
		});

		this.observerService.attach( this.goToPage, 'goToPage' );
	}
	
	private initShepherd = () => {
		
	if(this.previewFlag != null || this.previewFlag != undefined) return;	
	
	if(this.viewType === 'present' || this.sharedToken != "") return;
	
	let continueTour = this.setStorageKey("bookSingle");
		if(!continueTour){
			return;
	};
		
		// Creating Tour
		const tour = new Shepherd.Tour({
		  defaultStepOptions: {
		  	keyboardNavigation: true,
		  	exitOnEsc: true,
		    cancelIcon: {
		      enabled: true
		    },
		    classes: 'custom-davis-tour custom-davis-tour-book-single',
		    scrollTo: { behavior: 'smooth', block: 'center' }
		  },
		  useModalOverlay: true
		});
		
			this.apiService.getTypesByParent('helperTextBook'). 
			then( data => {
		if (this.bookCode.includes('_SE')) {
				if(this.bookDetails.disableSpreadViewFlag == false) {
					var elements = ['.menu-item-link[href="#table"]','a[data-target="#searchModalCenter"]'
			 		,'.link .shepherd-share-lesson a','.link .shepherd-help','.link .shepherd-tile-view a','#viewTypeSelector'
			 		,'.bottom-bar .minus-btn',''];
			 	
			 	data = data.filter( (element, index, arr) => {	return index != 1; });
				} else{
					var elements = ['.menu-item-link[href="#table"]','a[data-target="#searchModalCenter"]'
			 		,'.link .shepherd-share-lesson a','.link .shepherd-help','.link .shepherd-tile-view a'
			 		,'.bottom-bar .minus-btn',''];
			 		
			 		data = data.filter( (element, index, arr) => {    return index != 1 && index !=6; });
				}
				
			} else {
				if(this.bookDetails.disableSpreadViewFlag == false) {
					var elements = ['.menu-item-link[href="#table"]','.menu-item-link[href="#resource"]','a[data-target="#searchModalCenter"]'
			 		,'.link .shepherd-share-lesson a','.link .shepherd-help','.link .shepherd-tile-view a','#viewTypeSelector'
			 		,'.bottom-bar .minus-btn',''];
			 	
				} else {
					var elements = ['.menu-item-link[href="#table"]','.menu-item-link[href="#resource"]','a[data-target="#searchModalCenter"]'
			 		,'.link .shepherd-share-lesson a','.link .shepherd-help','.link .shepherd-tile-view a'
			 		,'.bottom-bar .minus-btn',''];
			 		
			 		data = data.filter( ( element, index ) => {    return index != 6; });
				}
			}
			for( let index = 0; index < data.length; index++){
				var position='left';
				if(index==3){
						position='bottom';
				}
				if(index < 4){
					if( $('.menu-item-link[href="#resource"]').length ) {
							tour.addStep({
								id: "step0"+(index+1),
								title: "0"+(index+1)+"/"+data.length,
								text:data[index].typeDescription,
								attachTo: {
					    		element:elements[index],
									    	on: position
											},
											buttons: [
										  	{
										      action() {
										        return this.complete();
										      },
										      classes: 'shepherd-button-stop-helper-temporarily',
										      text: 'Stop helper'
										    },
										    {
										      action() {
										        return this.complete();
										      },
										      classes: 'shepherd-button-stop-helper-forever',
										      text: 'Stop helper and don\'t show again'
										    },
										    {
										      action() {
										        return this.next();
										      },
										      classes: 'shepherd-button-next',
										      text: 'Next'
										    }
										  ],
										  beforeShowPromise: function() {
											return new Promise(function(resolve) {
												var element = $('.dashboard-wrapper');
												if (!element.hasClass('open-left-panel')){
													$('.dashboard-wrapper').addClass('open-left-panel');	
												}
												resolve();
											});
										  }
									});
								
							}
					if(index==3){
							 tour.addStep({
								  id: "step0"+(index+1),
								  title: "0"+(index+1)+"/"+data.length,
								  text:data[index].typeDescription,
								  attachTo: {
							    	element:elements[index],
							    	on: position
									},
								buttons: [
										  	{
										      action() {
										        return this.complete();
										      },
										      classes: 'shepherd-button-stop-helper-temporarily',
										      text: 'Stop helper'
										    },
										    {
										      action() {
										        return this.complete();
										      },
										      classes: 'shepherd-button-stop-helper-forever',
										      text: 'Stop helper and don\'t show again'
										    },
										    {
										      action() {
										        return this.next();
										      },
										      classes: 'shepherd-button-next',
										      text: 'Next'
										    }
										  ],
										  beforeShowPromise: function() {
											return new Promise(function(resolve) {
												var element = $('.dashboard-wrapper');
												if (!element.hasClass('open-left-panel')){
													$('.dashboard-wrapper').addClass('open-left-panel');	
												}
												setTimeout(function(){ 
														resolve();
													}, 300);
											});
										  }
						  
						});
			}else{
				 tour.addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: position
							},
						buttons: [
										  	{
										      action() {
										        return this.complete();
										      },
										      classes: 'shepherd-button-stop-helper-temporarily',
										      text: 'Stop helper'
										    },
										    {
										      action() {
										        return this.complete();
										      },
										      classes: 'shepherd-button-stop-helper-forever',
										      text: 'Stop helper and don\'t show again'
										    },
										    {
										      action() {
										        return this.next();
										      },
										      classes: 'shepherd-button-next',
										      text: 'Next'
										    }
										  ],
										  beforeShowPromise: function() {
											return new Promise(function(resolve) {
												var element = $('.dashboard-wrapper');
												if (!element.hasClass('open-left-panel')){
													$('.dashboard-wrapper').addClass('open-left-panel');	
												}
												resolve();
											});
										  }
						  
						});
			}
					
			}else
			{
				 tour.addStep({
						  id: "step0"+(index+1),
						  title: "0"+(index+1)+"/"+data.length,
						  text:data[index].typeDescription,
						  attachTo: {
					    	element:elements[index],
					    	on: position
							},
						buttons: [
										  	{
										      action() {
										        return this.complete();
										      },
										      classes: 'shepherd-button-stop-helper-temporarily',
										      text: 'Stop helper'
										    },
										    {
										      action() {
										        return this.complete();
										      },
										      classes: 'shepherd-button-stop-helper-forever',
										      text: 'Stop helper and don\'t show again'
										    },
										    {
										      action() {
										        return this.next();
										      },
										      classes: 'shepherd-button-next',
										      text: 'Next'
										    }
										  ]
									
						  
						});
			}
		}
			
			tour.start();
		}); 

	}
	
	//param: if tour is for a "new" item tour or "edit" item tour, will show helper so many times, returns false to exit helper
	private setStorageKey = (action : string ) => {
		
	//	let localStorageKey = action == "new" ? 'lesson_editor_new_tour_completed' : "lesson_editor_tour_completed";
	
		let localStorageKey = action;
		
		Shepherd.on('cancel', () => {
			if(!this.localStorageService.getItem(localStorageKey)){
				this.localStorageService.setItem(localStorageKey, '1');
				console.log(this.localStorageService.getItem(localStorageKey));
			} else if (this.localStorageService.getItem(localStorageKey) == '1') {
				this.localStorageService.setItem(localStorageKey, '2')
			} else if (this.localStorageService.getItem(localStorageKey) == '2'){
				this.localStorageService.setItem(localStorageKey, '3')
			} else if (this.localStorageService.getItem(localStorageKey) == '3'){
				return false;
			}
		});
	    
	    if(this.localStorageService.getItem(localStorageKey)){
			let storageKey = this.localStorageService.getItem(localStorageKey);
			if( storageKey != '1' && storageKey != '2')
	        return false;
	    }
	    
	    Shepherd.on('complete', (context, args) => {
	    	//ignore complete action if done from last step, so user can see it again on reload
	    		this.localStorageService.setItem(localStorageKey, Date.now());
	    });
	
		//return true to continue shepherd init
		return true;
	}
	
	private getBookDetails = () =>{
		if(this.bookID == null){
			this.bookID = this.$attrs.bookId;
		}
		
		return this.bookService.getBookDetails( this.bookID, this.sharedToken ).then((response)=>{
			this.bookDetails = response;
			this.bookCode = response?.bookCode;
			if( response?.sharedPageNumber != undefined ) {
				this.pageNumber = response.sharedPageNumber;
				this.viewAs = response.sharedViewAs;
			}
		})
	}
	
	public getCanvas = () =>{
		if(this.canvas){
			return this.canvas
		}
		this.canvas = document.getElementById('viewerContainer').querySelector('canvas');
		return this.canvas;
	}
	
	public getCoordinates = ( event ) => {
		
		this.canvas = this.getCanvas();


		if ( !this.selectingCoordinate ) {
			return false;
		}

		let elementPos = this.canvas.getBoundingClientRect();

		let xCoord = event.clientX - elementPos.left;
		let yCoord = event.clientY - elementPos.top;

		let spreadX = xCoord / this.canvas.clientWidth * 100;
		let yPercentage = yCoord / this.canvas.clientHeight * 100;

		let coordinates = {};

		if ( 'single' === this.viewAs || this.pageNumber === 1 ) {
			coordinates = {
				x: spreadX,
				y: yPercentage,
				pageID: this.pageIDs[0],
			}
		} else if ( 'spread' === this.viewAs ) {

			let isRightPage = spreadX > 50;

			let xPercentage = angular.copy( spreadX );
			if ( isRightPage ) {
				xPercentage = ( xPercentage - 50 ) * 2;
			} else {
				xPercentage *= 2;
			}

			coordinates = {
				x: xPercentage,
				y: yPercentage,
				spreadX: spreadX,
				pageID: this.pageIDs[ +isRightPage ],
			}

		}

		this.observerService.notify( 'canvasCoordinateClicked', coordinates );
		this.selectingCoordinate = false;
	}
	
	private getMediaContainer = () => {
		this.mediaContainer = document.getElementById('media-container');

		// Observe resize event to set the mediaWidth.
		const resizeObserver = new ResizeObserver((entries, observer) => {
			for ( const entry of entries ) {
				const { width } = entry.contentRect;
				// this.mediaWidth = width;
				if(this.pdfSinglePageViewerObj ){
				    this.pdfSinglePageViewerObj.currentScaleValue = "page-fit";
				    this.pdfViewerIntialScale = this.pdfSinglePageViewerObj.currentScale
				    this.zoom = 100;
					this.adjustZoom();
				}
				this.$scope.$apply();
			}
		});

		resizeObserver.observe( this.mediaContainer );
	}
	
	/**
	 * Helper Method returns true unless the page number is not available in the shared book case
	 * @param - pageNumber
	 * */
	private checkSharedPageList = ( pageNumber) => {
		
		if( this.sharedPageList === undefined || 
			this.sharedPageList.length === 0 
		){
			return true;
		}
		
		if( pageNumber === undefined) {
			return true;
		}
		
		if( this.sharedPageList.indexOf(pageNumber) === -1 ) {
			return true;
		}
		
		if(this.spread['leftPage'].pageNumber != pageNumber ) {
			return true;
		}

		return false;
	}
	
	/**
	 * Method to get correct page number from shared list based on next / prev action - it follows circular approach
	 * @param - pageNumber 
	 * @param - step:string = "next" / "prev"
	 * */
	private getSharedPageNumber( pageNumber, step:string = 'next' ) {
		for( let index = 0; index < this.sharedPageList.length; index++) {
			if( pageNumber == this.sharedPageList[index] ) {
				if( step === "next" && index === this.sharedPageList.length - 1) {
					return this.sharedPageList[0];
				} else if ( step === "prev" && index === 0 ) {
					return this.sharedPageList[ this.sharedPageList.length - 1 ];
				} else {
					return this.sharedPageList[ step == "next" ? index + 1 : index - 1 ];
				}
			}
		}
	}
	
	/**
	 * @param attemptCount : numeric 
	 * argument added to handle infinite API call in case of any bad data, since are also calling this method from renderMediaViewer method
	 **/
	
	private getSpreadForBook = (attemptCount:number = 0): any => {
		
		if ( isNaN( this.pageNumber ) ) {
			return false;
		}

		// Ensure the page requested is in range of the number of pages.
		if (
			this.numberOfPages !== null
			&& (
				( this.pageNumber > this.numberOfPages && this.checkSharedPageList(this.pageNumber) )
			)
		) {
			return false;
		}

		return this.bookService.getSpreadsForBook( this.bookID, this.pageNumber, 1 , this.sharedToken).then( data => {
			if ( data.pages != null && data.pages.length ) {
				this.spread = data.pages[0];

				this.setPageRepresentationFromSpread();
				if( this.sharedToken != "" && data.sharedPagesList != "" ) {
					this.sharedPageList = (data.sharedPagesList).split(",");
				}
				
				this.numberOfPages = data.totalPages;
				this.totalPageRepresentation = data.totalPageRepresentation;

				this.renderMediaViewer( attemptCount );
			} else {
				//set error message for shared content pages
				if( this.sharedToken != "" && data.errors != null && data.errors.sharedToken != null) {
					this.pageErrors = data.errors.sharedToken;
				}
			}
		});
	}

	private setPageRepresentationFromSpread = () =>{
		var representations = this.bookService.getPageRepresentationFromSpread(this.spread, this.pageNumber);
		this.pageRepresentation = representations['pageRepresentation'];
		this.spreadPageRepresentation = representations['spreadPageRepresentation'];
	}
	
	/**
	* not included in current scope
	**/
	private getPageNotes = (): void => {
		this.pageNotes = [];
		this.pageIDs.forEach( pageID => {
		return this.bookService.getPageNotesForPage( this.bookID, pageID ).then( data => {
				if ( 'undefined' !== typeof data ) {
					let pageNotes = this.getNoteSpreadCoordinates( data );
					this.pageNotes = this.pageNotes.concat( pageNotes );
				}
			})
		})
	}

	private getChapters = (): void => {

		// If we already have chapters, return.
		if ( this.chapters.length > 0 ) {
			return;
		}

		return this.bookService.getChaptersByBookID( this.bookID ).then( data => {
			this.chapters = data;
			this.getActiveChapters();
		})
	}

	private getResources = (doAfter?: () => void): void => {
		let forceUpdate = (this.s3LinkExpireyTime != null && this.s3LinkExpireyTime > 0 && new Date().getTime() > this.s3LinkExpireyTime);
		return this.bookService.getResourcesByBookID( this.bookID, 'all', forceUpdate ).then( dataResponse => {
			this.resources = this.bookService.sortResourcesByFormat( dataResponse );
			if ( dataResponse.length ) {
				for ( let dataResponseIndex = 0; dataResponseIndex < dataResponse.length; dataResponseIndex++ ) {
					if ( dataResponse[dataResponseIndex].type_systemCode === 'btVideos' ) {
						this.s3LinkExpireyTime = new Date(dataResponse[dataResponseIndex].linkGenerationTime)
												.addMinutes(dataResponse[dataResponseIndex].linkExpiryMinutes)
												.getTime();
						break;
					}
				}
			}
			if ( this.resources.brftVideo && this.resources.brftVideo.length ) {
				const tmpResources = [];
				
				this.resources.brftVideo.forEach(res => {
					let loweredLinkTitle = res.title.toLowerCase();
					if ( tmpResources.findIndex(v => v.title.toLowerCase() === loweredLinkTitle) < 0 ) {
						tmpResources.push(res);
					}
				});
				this.resources.brftVideo = tmpResources;
			}
		}).finally(() => {
			doAfter && doAfter();
		})
	}

	private getNoteSpreadCoordinates = ( pageNotes ) => {
		pageNotes.forEach(( note, index ) => {
			let spreadX = note.xCoordinate / 2;

			if ( 'undefined' !== typeof this.pageIDs[1] && this.pageIDs[1] === note.page_pageID ) {
				spreadX += 50;
			}

			pageNotes[ index ].spreadX = spreadX;
		});

		return pageNotes;
	}

	/**
	 * Rendering function
	 * @param attemptCount : numeric 
	 * argument added to handle infinite API call in case of any bad data, since are also calling this method from getSpreadForBook method
	 * 
	**/
	protected renderMediaViewer = (attemptCount: number = 0) => {
		
		this.isRendering = true;
		
		//block the process if number of attempts to load the page exceeds 3
		if( attemptCount > 3 ) {
			console.warn("Attempted 3 page renders can't resolve requested page data.");
			return;
		}

		let hasSharedToken = ( this.sharedToken != null && this.sharedToken?.length );

		let spreadKey = ( this.pageNumber % 2 || hasSharedToken ) 
						? 'leftPage' 
						: 'rightPage';
		

		// If we don't have the correct spread, fetch it before we render.
		if (
			'undefined' === typeof this.spread
			|| 'undefined' === typeof this.spread[ spreadKey ]
			|| ( this.spread[ spreadKey ].pageNumber !== this.pageNumber 
				&& this.checkSharedPageList(this.pageNumber) )
		) {
			this.getSpreadForBook( attemptCount + 1 );
			return;
		}
		
		//Show single view when it is setAs view OR when showing for cover OR when spread has only one left side for spread view
		if ( 'single' === this.viewAs || 'cover' === spreadKey || ( this.viewAs === 'spread' && this.spread?.rightPage === undefined) ) {
			let currentPage = this.spread[ spreadKey ];

			this.pageIDs = [ currentPage.pageID ];
			this.pageImages = currentPage.imageMap;
			this.pageVideos = currentPage.videoMap;
			this.hasPageImages = Object.keys(this.pageImages).length > 0 || Object.keys(this.pageVideos).length > 0;
			if ( currentPage.pathToPDF.length ) {
		        this.renderPDF(currentPage.pathToPDF);
			} else {
				this.renderImage( currentPage.pathToLargeImage );
			}

		} else if ( 'spread' === this.viewAs ) {
			if ( this.spread.pathToSpreadPDF.length ) {
				this.renderPDF( this.spread.pathToSpreadPDF );
			} else {
				this.renderImage( this.spread.pathToSpreadImage );
			}

			this.pageIDs = [ this.spread.leftPage.pageID ];
			this.pageImages = this.spread.leftPage.imageMap;
			this.pageVideos = this.spread.leftPage.videoMap;
			
			if ( 'undefined' !== typeof this.spread.rightPage ) {
				this.pageIDs.push( this.spread.rightPage.pageID );
				
				Object.assign(this.pageImages, this.spread.rightPage.imageMap);
				Object.assign(this.pageVideos, this.spread.rightPage.videoMap);
				
				this.hasPageImages = Object.keys(this.pageImages).length > 0 || Object.keys(this.pageVideos).length > 0;
			}
		}
		
		//open / close book page asset modal
		this.observerService.notify( 'openPageAsset', this.hasPageImages);


		//we should only do these if we need to
		this.setPageRepresentationFromSpread();
		
		this.getActiveChapters();
	}

	private renderImage = ( imageURL: string ): void => {
		this.currentImageURL = imageURL;
		this.renderType = 'image';
	}
	
	public renderPDF = (pdfURL: string): void => {
		this.isRendering = true;
	    var eventBus = new pdfjsViewer.EventBus();
	    // (Optionally) enable hyperlinks within PDF files.
	    var pdfLinkService = new pdfjsViewer.PDFLinkService({
	      eventBus: eventBus,
	    });
	
	    // (Optionally) enable find controller.
	    var pdfFindController = new pdfjsViewer.PDFFindController({
	      eventBus: eventBus,
	      linkService: pdfLinkService,
	    });
	
	    this.pdfSinglePageViewerObj = new pdfjsViewer.PDFSinglePageViewer({
	      container: this.pdfContainer,
	      eventBus: eventBus,
	      linkService: pdfLinkService,
	      findController: pdfFindController,
	      removePageBorders: true,
	    });
	
	    pdfLinkService.setViewer(this.pdfSinglePageViewerObj);
	
	    eventBus.on("pagesinit", () => {
	      // We can use pdfSinglePageViewer now, e.g. let's change default scale.
	      this.pdfSinglePageViewerObj.currentScaleValue = "page-fit";
	      this.pdfViewerIntialScale = this.pdfSinglePageViewerObj.currentScale;
	      this.pdfSinglePageViewerObj.currentPageNumber = 1;
	      this.isRendering = false;
	      // We can try searching for things.
	      if (this.searchedKeyword) {
	        // pdfFindController.executeCommand("find", { query: SEARCH_FOR });
	        pdfFindController.executeCommand("findhighlightallchange", {
	          query: this.searchedKeyword,
	          phraseSearch: true,
	          caseSensitive: false,
	          entireWord: false,
	          highlightAll: true,
	          findPrevious: false,
	        });
	      }
    });

	    // Loading document.
	    var loadingTask = pdfjsLib.getDocument({
	      url: pdfURL,
	    });
	    loadingTask.promise.then((pdfDocument) => {
	      // Document loaded, specifying document for the viewer and
	      // the (optional) linkService.
	      this.pdfSinglePageViewerObj.setDocument(pdfDocument);
	      pdfLinkService.setDocument(pdfDocument, null);
	    });
  };

	// Pagination Functions.
	public nextPage = (): void => {

		if (  (this.pageNumber >= this.numberOfPages  ||  ( 'spread' === this.viewAs && this.pageNumber + 1 > this.numberOfPages ) ) 
			 && this.checkSharedPageList(this.pageNumber)
		) {
			return;
		}
		
		let pageNumber = this.pageNumber;
		
		//override page number value
		if ( this.sharedToken !== "" ) {
			pageNumber = this.getSharedPageNumber(pageNumber, "next");
		} else {
			pageNumber = ( 'spread' === this.viewAs && this.pageNumber + 2 <= this.numberOfPages ) ?  this.pageNumber + 2 :  this.pageNumber + 1;
		}
		
		this.goToPage( pageNumber );
	}

	public prevPage = (): void => {
		if ( this.pageNumber <= 1 && this.checkSharedPageList(this.pageNumber)  ) {
			return;
		}

		let pageNumber = this.pageNumber;
		
		//override page number value
		if ( this.sharedToken !== "" ) {
			pageNumber = this.getSharedPageNumber(pageNumber, "prev");
		} else {
			pageNumber = ( 'spread' === this.viewAs && this.pageNumber > 2 ) ?  this.pageNumber - 2 :  this.pageNumber - 1;
		}
		
		this.goToPage( pageNumber );
	}

	public goToPage = ( pageSearchObj: any ) => {
	    if ( pageSearchObj && typeof pageSearchObj === "object" && pageSearchObj.constructor === Object) {
	      this.pageNumber = pageSearchObj.pageNumber;
	      this.searchedKeyword = pageSearchObj.searchedKeyword;
	    } else {
	      this.pageNumber = pageSearchObj;
	    }
	    this.$location.search("pageNumber", this.pageNumber);
	    this.renderMediaViewer();
	    $(".modal").modal("hide");
	}


	// Zoom functions.
	public adjustZoom = (adjustmentAmmount: number = 0) => {
	    let newZoom = +this.zoom + adjustmentAmmount;
	    if (newZoom > 300 || newZoom < 100) {
	      return;
	    }
	    if(newZoom == 100){
	    	this.pdfSinglePageViewerObj.currentScaleValue = this.pdfViewerIntialScale;
	    }else{
		    this.pdfSinglePageViewerObj.currentScaleValue = ((newZoom / 100) * this.pdfViewerIntialScale).toFixed(2);
	    }

	    this.zoom = newZoom;

	    // Update the range slider manually since direct ng-model changes doesn't trigger our library to update.
	    this.$timeout(() => this.zoomSlider.rangeslider("update", true));
	};
	  
	public toggleZoom = (): void => {
		 this.zoom = ( this.zoom !== 200 ) ? 200 : 100;
		 this.adjustZoom();
		
	}


	private renderRangeSlider = (): void => {

		this.zoomSlider = $('#bookRangeSlider');

		this.zoomSlider.rangeslider({
			polyfill: false,

			onInit: function() {
				// Create our visual percentage display.
				this.output = $( '<div class="rangeslider__output" />' )
					.appendTo('.rangeslider__handle')
					.html( '<label for="bookRangeSlider">' + this.$element.val() + '%</labe>' );
			},

			onSlide: function( position, value ) {
				this.output.html( value + '%' );
			}
		});
	}

	public changeView = (): void => {
		// If we're switching to a spread and the number is even, we need to subtract one from it
		if ( 'spread' === this.viewAs && this.pageNumber > 1 && this.pageNumber % 2 ) {
			this.pageNumber--;
		}
		
		this.$location.search( 'viewAs', this.viewAs );

		this.renderMediaViewer();
	}

	public openSearchWithKeyword = ( keyword: string ) => {
		this.observerService.notify( 'searchPagesByKeyword', keyword )
		$('#searchModalCenter').modal();
	}

	public togglePresentationMode = () => {
		this.isPresentationMode = !this.isPresentationMode;

		document.getElementsByTagName('body')[0].classList.toggle('presentation-mode');
	}

	public getActiveChapters = () => {
		this.chapters.forEach( ( chapter, index ) => {

			if ( 'single' === this.viewAs || ('spread' === this.viewAs && this.spread?.rightPage === undefined) ) {
				if ( 'undefined' !== typeof this.chapters[ index + 1 ] ) {
					// If the page matches exactly, or is inbetween the current & next chapter.
					this.chapters[ index ].isActive = (
						chapter.pageStart == this.pageNumber
						|| (
							chapter.pageStart < this.pageNumber
							&& this.chapters[ index + 1 ].pageStart > this.pageNumber
						)
					);
				} else {
					this.chapters[ index ].isActive = ( chapter.pageStart <= this.pageNumber );
				}
			} else if ( 'spread' === this.viewAs && 1 !== this.pageNumber ) {
				let leftPage = this.spread?.leftPage?.pageNumber;
				let rightPage = ( 'undefined' !== this.spread?.rightPage ) ? this.spread?.rightPage.pageNumber : null;

				if ( 'undefined' !== typeof this.chapters[ index + 1 ] ) {
					// If the page matches exactly, or is inbetween the current & next chapter.
					this.chapters[ index ].isActive = (
						chapter.pageStart == leftPage
						|| chapter.pageStart == rightPage
						|| (
							chapter.pageStart < leftPage
							&& this.chapters[ index + 1 ].pageStart > rightPage
						)
					);
				} else {
					this.chapters[ index ].isActive = ( chapter.pageStart <= leftPage );
				}
			}
		});
	}

	public goToPageByRepresentation = ($event: Event): void => {
		$event.stopPropagation();
		$event.preventDefault();
		if ( this.goToValue ) {
			if ( this.bookDetails.pageRepresentations[ this.goToValue.toUpperCase() ] !== undefined ) {
				this.goToPage( this.bookDetails.pageRepresentations[ this.goToValue.toUpperCase() ] );
				this.goToValue = "";
			} else {
				this.davisAlertService.error( 'Could not find requested page' );
			}
		} else {
			this.davisAlertService.error( 'Please enter a page' );
		}
	}

	public toggleSelectMediaCoordinate = () => {

		if ( this.pageNotes.filter( note => note.pageNoteID === '' ).length > 0 ) {
			return;
		}

		this.selectingCoordinate = !this.selectingCoordinate;
		this.isNotesVisible = !this.selectingCoordinate;
	}

	public selectNote = ( index ) => {
		this.observerService.notify( 'selectedNote', index )
	}

	public toggleNotesShow = () => {
		this.isNotesVisible = !this.isNotesVisible;
	}

	//Initialize page share attributes
	public initPageShare() {
		this.pageShareSuccess = false;
		this.pageShareEmail = "";
		this.pageShareBody = "";
		this.pageShareSubject = 'Davis Digital Content';
		this.pageShareLoading = false;
	}

	public pageShare () {

		//Call API to share Page
		let formData = {
			emailAddress : this.pageShareEmail,
			subject: this.pageShareSubject,
			message: this.pageShareBody,
			pageID: this.pageIDs[0],
			viewAs: this.viewAs
		};
		this.pageShareLoading = true;
		this.bookService.pageShare( formData ).then( data => {
			if( data.successfulActions.length ) {
				this.pageShareSuccess = true;
				this.pageShareLoading = false;
			}
		});
	}

	public openVideoPlayer = ( resource ) => {
		if (new Date().getTime() > this.s3LinkExpireyTime) {
			const {title, pageNumber} = resource;
			this.getResources(() => {
				let newResource = this.resources.brftVideo.find((v: any) => v.title === title && v.pageNumber === pageNumber);
				if (newResource) {
					this._openVideoPlayer( newResource );
				} else {
					this.davisAlertService.error(`Issue loading video "${resource.title}", Please try again.`);
				}
			});
		} else {
			this._openVideoPlayer( resource );
		}
	}
	
	private _openVideoPlayer = ( resource ) => {
		this.activeVideoResource = resource;
		if ( resource.embed && resource.embed.trim() ) { // check for " "
			this.activeVideoResource.trustedHtmlEmbed = this.$sce.trustAsHtml( resource.embed );
		} else {
			this.activeVideoResource.videoUrl = this.$sce.trustAsResourceUrl( resource.s3PathToResourceFile );
		}
		$('#bookSingleVideoModal').modal();
	}

	public downloadResource = ( resource ) => {
		this.bookService.downloadResourcePDF( resource );
	}
}

export { BookSingleController };
